import sortBy from 'lodash/sortBy';
import React, { memo, useMemo, useRef } from 'react';

import BuildingLayer from './BuildingLayer';

import type { BUILDINGS } from '~/Actions/ActionSupply';
import type { ISupplyBuildings } from '~/store/slices/settingsSlice';
import type { IBattlesStats } from '~/types/declaration';
import type { Nullable } from '~/types/generics';

type IBuildingsLayerProps = {
  battlesStats: IBattlesStats;
  buildings: ISupplyBuildings;
  edgesVisible: Partial<Record<BUILDINGS, boolean>>;
  highlightDelay: number;
  isMapBlured: boolean;
  selectedBuildingId: Nullable<BUILDINGS>;
  confirmBuildingId: Nullable<BUILDINGS>;
  tempHoverBuildingLevel: Nullable<number>;
  zoom: number;
  setHighlightedBuilding: (buildingId: Nullable<BUILDINGS>) => void;
  selectBuilding: (buildingId: BUILDINGS, needSavePosition?: boolean) => void;
};

const BuildingsLayer: React.FC<IBuildingsLayerProps> = ({
  battlesStats,
  buildings,
  edgesVisible,
  highlightDelay,
  isMapBlured,
  selectedBuildingId,
  confirmBuildingId,
  tempHoverBuildingLevel,
  zoom,
  setHighlightedBuilding,
  selectBuilding,
}) => {
  const highlightTimers = useRef<Partial<Record<BUILDINGS, ReturnType<typeof setTimeout>>>>({});
  const tooltipTimers = useRef<Partial<Record<BUILDINGS, ReturnType<typeof setTimeout>>>>({});

  const sortedBuildings = useMemo(() => sortBy(Object.values(buildings), 'order'), [buildings]);

  return (
    <>
      {sortedBuildings.map((building) => (
        <BuildingLayer
          key={building.name}
          battlesStats={battlesStats}
          building={building}
          highlightDelay={highlightDelay}
          highlightTimers={highlightTimers}
          isEdgesVisible={edgesVisible[building.name] || false}
          isMapBlured={isMapBlured}
          selectedBuildingId={selectedBuildingId}
          confirmBuildingId={confirmBuildingId}
          tempHoverBuildingLevel={tempHoverBuildingLevel}
          tooltipTimers={tooltipTimers}
          zoom={zoom}
          setHighlightedBuilding={setHighlightedBuilding}
          selectBuilding={selectBuilding}
        />
      ))}
    </>
  );
};

export default memo(BuildingsLayer);
